import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import TestimonialForm from "./TestimonialForm";
import { getTestimonials } from '../../../redux/actions/testimonials';
import { testimonialService } from '../../../services/testimonials';
const moment = require('moment');
const queryString = require('query-string');

class CustomerTestimonials extends Component {
  constructor(props) {
    super(props);
    const parsed = queryString.parse(window.location.search);
    this.state = {
      isHovered: false,
      approvalToken: parsed.token || null
    };
    this.handleHover = this.handleHover.bind(this);
  }

componentDidMount() {
  const { approvalToken } = this.state;

  if (approvalToken) {
    testimonialService.approveByToken(approvalToken)
      .then(response => {
        // Optionally show a success message
        console.log("Approved successfully");
        this.props.getTestimonials(null, '', '', '', false);
      })
      .catch(error => {
        // Token might be expired/invalid — just log and continue
        console.warn("Token invalid or already used:", error);
        this.props.getTestimonials(null, '', '', '', false);
      });
  } else {
    this.props.getTestimonials(null, '', '', '', false);
  }
}


  handleHover() {
    // this.setState(prevState => ({
    //     isHovered: !prevState.isHovered
    // }));

    $("#clients div.client").hover(function () {
      $("#clients div.client").removeClass("pink_gradient")
      $(this).addClass("pink_gradient")
    }, function () {
      $("#clients div.client").removeClass("pink_gradient")
    })
  }
  render() {
    const { testimonails } = this.props;
    const breaks = <React.Fragment>
      <br /><br /><br />
    </React.Fragment>;
    

    return (
      <React.Fragment>

        <section id="contactUs" className="section bg_alter">
          <div className="container">
            <div className="row">
              <TestimonialForm />
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container mt-xlg">
            <div className="row mb-xlg">
              <div className="col-md-12 mb-xlg"><h2 className="panel_heading">Customer Testimonials</h2></div>
            </div>
            {
              testimonails.data.map(testimonail => {
                return (
                  <div key={testimonail.id} className="row testimonialsTimeline">
                    <div className="col-md-6">
                      <div className="text_16">
                        {testimonail.description}
                        {testimonail.description.length < 1000 ? breaks : ''}
                        <div></div>
                        <div className="testiAuthor">
                          <div className="name">{testimonail.author}</div>
                          <div className="company">{testimonail.company}</div>
                          <div className="date">{moment(testimonail.created_at).format('MMM DD YYYY')}</div>
                        </div>
                      </div>

                      <div className="speak-bubble"><span>❝</span></div>
                    </div>
                  </div>
                )
              })
            }

          </div>
        </section>
      </React.Fragment >
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getTestimonials: (brand_id, pageSize, sort, filter, is_admin) => { dispatch(getTestimonials(brand_id, pageSize, sort, filter, is_admin)) }
  }
}
const mapStateToProps = (state) => {
  const { testimonails, pages, perPage, current_page } = state.testimonialReducer;
  return {
    testimonails, pages, perPage, current_page
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(CustomerTestimonials)


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Testimonials/CustomerTestimonials.jsx